var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-side-menu-content',[_c('form-component'),(_vm.isEdit)?_c('button-update'):_c('button-edit')],1)}
var staticRenderFns = []

export { render, staticRenderFns }